import { Navigate, useLocation } from "react-router-dom";

export default function AuditLogRedirect() {
  const location = useLocation();
  // Redirect from /people/:pgaId/person/audit-log to /people/:pgaId/person/change-history
  const newPath = location.pathname.replace("/audit-log", "/change-history");
  return <Navigate to={`${newPath}${location.search}`} replace />;
}
